// Wording carried over from the owner’s published policy at
// https://karalewich.com/privacy-policy (retrieved 3 November 2026).
export const privacyIntroduction =
  "Karalewich Consulting (“we”, “our”, “us”) is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal information when you visit our website, [karalewich.com] (the “Website”). By using our Website, you consent to the practices described in this Privacy Policy.";
export const privacySections = [
  {
    title: "1. Information We Collect",
    content: [
      {
        type: "paragraph",
        text: "We may collect personal information directly from you and through your interaction with our Website. This includes:",
      },
      {
        type: "list",
        items: [
          "Personal Information: Name, email address, phone number, and any other information you provide when filling out a contact form or subscribing to our services.",
          "Technical Information: IP address, browser type, device type, and information about your interactions with the Website (such as pages visited and time spent on the site).",
          "Cookies and Tracking Technologies: We use cookies and similar technologies to enhance your experience on our Website and analyze user behavior.",
        ],
      },
    ],
  },
  {
    title: "2. How We Use Your Information",
    content: [
      {
        type: "paragraph",
        text: "We may use the information collected from you for the following purposes:",
      },
      {
        type: "list",
        items: [
          "To provide and maintain our Website and services.",
          "To respond to your inquiries and provide customer support.",
          "To send you newsletters, marketing communications, or promotional offers (with your consent).",
          "To analyze user behavior and improve the functionality of our Website.",
          "To comply with legal obligations or protect our legal rights.",
        ],
      },
    ],
  },
  {
    title: "3. Sharing Your Information",
    content: [
      {
        type: "paragraph",
        text: "We do not sell or share your personal information with third parties for their marketing purposes. However, we may share your information in the following circumstances:",
      },
      {
        type: "list",
        items: [
          "Service Providers: We may share your data with trusted third-party service providers who assist us in operating our Website or conducting our business (such as hosting services or analytics providers).",
          "Legal Compliance: We may disclose your information to comply with legal obligations, enforce our policies, or respond to lawful requests from public authorities.",
          "Business Transfers: In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the transaction.",
        ],
      },
    ],
  },
  {
    title: "4. Data Security",
    content: [
      {
        type: "paragraph",
        text: "We take appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. While we strive to protect your data, no method of transmission over the Internet or electronic storage is 100% secure. Therefore, we cannot guarantee the absolute security of your information.",
      },
    ],
  },
  {
    title: "5. Your Data Protection Rights",
    content: [
      {
        type: "paragraph",
        text: "Depending on your location, you may have the following rights regarding your personal information:",
      },
      {
        type: "list",
        items: [
          "Access: You have the right to request a copy of the personal data we hold about you.",
          "Correction: You may request that we correct any inaccuracies in your personal data.",
          "Deletion: You may request that we delete your personal data, subject to certain legal obligations.",
          "Objection: You have the right to object to the processing of your personal data for direct marketing or other purposes.",
        ],
      },
      {
        type: "paragraph",
        text: "If you would like to exercise any of these rights, please contact us at hello@karalewich.com .",
      },
    ],
  },
  {
    title: "6. Cookies and Tracking Technologies",
    content: [
      {
        type: "paragraph",
        text: "Our Website uses cookies to enhance your browsing experience. Cookies are small text files stored on your device that help us recognize returning visitors and analyze site usage. You can control cookie settings through your browser or decline their use, though this may affect your ability to use certain features of the Website.",
      },
    ],
  },
  {
    title: "7. Third-Party Links",
    content: [
      {
        type: "paragraph",
        text: "Our Website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to read the privacy policies of any linked websites you visit.",
      },
    ],
  },
  {
    title: "8. Changes to This Privacy Policy",
    content: [
      {
        type: "paragraph",
        text: "We may update this Privacy Policy from time to time to reflect changes in our practices or applicable laws. When we do, we will revise the “Last Updated” date at the top of this page. We encourage you to review this Privacy Policy periodically for any updates.",
      },
    ],
  },
  {
    title: "9. Contact Us",
    content: [
      {
        type: "paragraph",
        text: "If you have any questions about this Privacy Policy or our data practices, please contact us at:",
      },
      {
        type: "paragraph",
        text: "Karalewich LLC",
      },
      {
        type: "paragraph",
        text: "Email: hello@karalewich.com",
      },
      {
        type: "paragraph",
        text: "Phone: 201-500-5343",
      },
    ],
  },
];
